import React, {useState} from 'react'

function WidgetSpacer() {
    return <div
        className="vc_separator wpb_content_element vc_separator_align_center vc_sep_width_100 vc_sep_pos_align_center vc_separator_no_text vc_custom_1598791803163  vc_custom_1598791803163 btn_border">
    <span className="vc_sep_holder vc_sep_holder_l"><span style={{"borderColor": "#dcdcdc"}}
                                                          className="vc_sep_line">

    </span>
    </span>
        <span className="vc_sep_holder vc_sep_holder_r"><span style={{"borderColor": "#dcdcdc"}}
                                                              className="vc_sep_line">

    </span>
    </span>
    </div>
}


export default WidgetSpacer;
